import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import Navbar from "./components/Navbar.vue";
import { useRouter } from "vue-router";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const showNavbar = ref(false);
const router = useRouter();

router.beforeEach((to, from, next) => {
  showNavbar.value = !to.path.startsWith('/admin') && to.path !== '/login';
  next();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showNavbar.value)
      ? (_openBlock(), _createBlock(Navbar, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ], 64))
}
}

})